import React, { useRef } from "react"
import { Platform, TouchableOpacity, View } from "react-native"
import { CameraView } from "expo-camera"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import MicrophoneLevelIndicatorM from "@common/components/microphone/MicrophoneLevelIndicatorM"
import { PlaySoundM } from "@common/components/playSound/PlaySoundM"
import TextM from "@common/components/text/TextM"
import { usePermissions } from "@common/livekit/components/PermissionBanner"
import { theme } from "@common/theme/theme"
import AvatarGroupM from "@common/components/avatar/AvatarGroupM"
import { onAvatarPress } from "@common/livekit/components-web/StudentControlBar"
import { informationWarning } from "../../../tutor/lives/MoveSessionReasonComponent"

/**
 * L'écran d'entrée d'avant le test guidé : aperçu, bouton « tester le son »,
 * barres du micro.
 *
 * Il ne reste que le repli d'une séance introuvable : quand `live_sessions`
 * n'arrive pas dans les six secondes, on sert cet écran, qui n'a besoin de
 * rien pour s'afficher, plutôt qu'un chargement sans fin. Il a été le repli
 * des salles sans drapeau pendant la journée de pilote du 15/09. Il reproduit
 * l'ancien `PreCallScreen` sans le modifier : le bouton d'entrée et Sam
 * restent dans l'écran parent.
 */
const LegacyPreCallCheck = ({ width, height, isVideoMuted, onToggleVideo, ratio, liveStudents }) => {
    const cameraRef = useRef()
    const { permissionsGranted, requestPermissions } = usePermissions()

    return (
        <>
            <View
                style={{
                    width,
                    alignItems: "center",
                    height,
                    borderRadius: 25,
                    overflow: "hidden",
                    marginTop: 10,
                    backgroundColor: theme.colors.black,
                }}
            >
                {!isVideoMuted && (
                    <CameraView
                        style={{ alignSelf: "center", width, height }}
                        useCamera2Api={true}
                        type={"front"}
                        facing={"front"}
                        ref={cameraRef}
                        onMountError={() => {}}
                        onCameraReady={() => {}}
                        ratio={ratio ?? "4:3"}
                    />
                )}
                {!permissionsGranted.camera && (
                    <TouchableOpacity
                        onPress={requestPermissions}
                        style={{ position: "absolute", top: 10, right: 10 }}
                    >
                        <FontAwesome5 name="exclamation-triangle" size={24} color={theme.colors.warning} />
                    </TouchableOpacity>
                )}
                <View
                    style={{
                        flexDirection: "row",
                        alignItems: "center",
                        width,
                        alignSelf: "center",
                        justifyContent: "space-around",
                        position: "absolute",
                        bottom: 20,
                    }}
                >
                    <TouchableOpacity style={{ alignItems: "center" }} onPress={onToggleVideo}>
                        <FontAwesome5
                            name={isVideoMuted ? "video-slash" : "video"}
                            size={30}
                            color={theme.colors.white}
                            style={{ marginRight: 10 }}
                        />
                        <TextM color={theme.colors.white} wrap>
                            {isVideoMuted ? "Video désactivée" : "Video activée"}
                        </TextM>
                    </TouchableOpacity>
                </View>
                <AvatarGroupM
                    users={liveStudents}
                    style={{ marginHorizontal: 10 }}
                    size={24}
                    onPress={() => onAvatarPress(liveStudents)}
                />
            </View>

            <TouchableOpacity
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                    width,
                    alignSelf: "center",
                    justifyContent: "center",
                    marginTop: 15,
                }}
                onPress={() => PlaySoundM.play(require("@assets/sounds/maximize_001_low.mp3"))}
            >
                <FontAwesome5
                    name={"volume-up"}
                    size={25}
                    color={theme.colors.primary}
                    style={{ marginRight: 10 }}
                />
                <TextM color={theme.colors.primary} fontWeight={"Bold"} style={{ textAlign: "center" }}>
                    TESTER LE SON
                </TextM>
            </TouchableOpacity>
            <MicrophoneLevelIndicatorM
                permissionsGranted={permissionsGranted}
                style={{ width, alignSelf: "center", marginTop: 15 }}
            />
            {Platform.OS === "android" &&
                informationWarning(
                    <>
                        <TextM
                            color={theme.colors.grey}
                            fontWeight={"SemiBold"}
                            style={{ textAlign: "center", marginTop: 0 }}
                            wrap
                        >
                            Pour une meilleure expérience, utilise des écouteurs ou un casque
                        </TextM>
                    </>,
                    { marginTop: 15 }
                )}
        </>
    )
}

export default LegacyPreCallCheck
